import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Signup from "./components/auth/Register";
import { useAuth } from "./components/Context/AuthContext";
import EmailVerificationNotice from "./components/auth/EmailVerificationNotice";
import VerifyEmail from "./components/auth/VerifyEmail";
import Login from "./components/auth/Login";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import Home from "./components/Home";
import ProtectedRoute from "./components/Context/ProtectedRoute";
import VerifyChangeEmail from "./components/Settings/VerifyChangeEmail";
import ComputerReport from "./components/Inventory/ComputerReport";
import ViewInvoice from "./components/invoices/ViewInvoice";
import ViewDeliveryNote from "./components/DeliveryNotes/ViewDeliveryNote";
import ViewReceipt from "./components/Receipts/ViewReceipt";
import ViewLocalPurchaseOrder from "./components/LocalPurchaseOrders/ViewLocalPurchaseOrder";
import NotFoundPage from "./components/Helpers/NotFoundPage";

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <>
      <Routes>
        {/* user want this disabled  */}
        {/* <Route path="/signup" element={<Signup />} /> */}
        <Route
          path="/email-verification"
          element={<EmailVerificationNotice />}
        />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route
          path="/verify-changedemail/:token"
          element={<VerifyChangeEmail />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route element={<ProtectedRoute allowedRoles={["Admin", "User"]} />}>
          <Route path="/" element={<Home />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["Admin", "User"]} />}>
          <Route path="/report/:id" element={<ComputerReport />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["Admin", "User"]} />}>
          <Route path="/invoice/:id" element={<ViewInvoice />} />
        </Route>
        <Route element={<ProtectedRoute allowedRoles={["Admin", "User"]} />}>
          <Route path="/deliverynote/:id" element={<ViewDeliveryNote />} />
        </Route>
        <Route element={<ProtectedRoute allowedRoles={["Admin", "User"]} />}>
          <Route path="/receipt/:id" element={<ViewReceipt />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["Admin", "User"]} />}>
          <Route path="/lpo/:id" element={<ViewLocalPurchaseOrder />} />
        </Route>
        {/*
        <Route
          path="/verify-email-change/:token"
          element={<VerifyEmailChange />}
        />
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
        />
        <Route
          path="/signup"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Signup />}
        />
        */}
        {/* Protected routes */}

        {/* Catch-all 404 route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
